import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CopyAllButtonProps {
  items: string[];
  separator?: string;
  className?: string;
  iconClassName?: string;
  label?: string;
}

export function CopyAllButton({
  items,
  separator = '\n',
  className = '',
  iconClassName = 'h-4 w-4 mr-2',
  label = 'Copy All'
}: CopyAllButtonProps) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(items.join(separator));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={copyToClipboard}
      className={`inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md ${
        copied
          ? 'text-green-700 bg-green-50 border-green-200'
          : 'text-gray-700 bg-white hover:bg-gray-50 border-gray-300'
      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200 ${className}`}
    >
      {copied ? (
        <>
          <Check className={iconClassName} />
          Copied!
        </>
      ) : (
        <>
          <Copy className={iconClassName} />
          {label}
        </>
      )}
    </button>
  );
}
